import { FC } from 'react';
import {
  UpcomingBookings,
  AvailabilitySection,
  ScheduleSection,
  EarningsSection,
  ClientsSection,
  ProfileSection,
  NotificationsSection,
} from '../../../components/dashboard/therapist';
import { OverviewSection } from './OverviewSection';
import type {
  TherapistDashboardSection,
  TherapistDashboardStats,
  TherapistProfile,
  TherapistAppointment,
} from '../../../types/therapist-dashboard.types';

interface SectionRendererProps {
  activeSection: TherapistDashboardSection;
  userName: string | undefined;
  stats: TherapistDashboardStats | undefined;
  profile: TherapistProfile | undefined;
  statsLoading: boolean;
  profileLoading: boolean;
  appointmentsLoading: boolean;
  upcomingAppointments: TherapistAppointment[];
  onSectionChange: (section: TherapistDashboardSection) => void;
  onUpdateStatus: (appointmentId: string, status: 'completed' | 'no_show' | 'cancelled') => void;
}

export const SectionRenderer: FC<SectionRendererProps> = ({
  activeSection,
  userName,
  stats,
  profile,
  statsLoading,
  profileLoading,
  appointmentsLoading,
  upcomingAppointments,
  onSectionChange,
  onUpdateStatus,
}) => {
  switch (activeSection) {
    case 'overview':
      return (
        <OverviewSection
          userName={userName}
          stats={stats}
          profile={profile}
          statsLoading={statsLoading}
          profileLoading={profileLoading}
          appointmentsLoading={appointmentsLoading}
          upcomingAppointments={upcomingAppointments}
          onSectionChange={onSectionChange}
          onUpdateStatus={onUpdateStatus}
        />
      );

    case 'appointments':
      return (
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100 mb-6">Upcoming Bookings</h2>
          <UpcomingBookings
            appointments={upcomingAppointments}
            isLoading={appointmentsLoading}
            onUpdateStatus={onUpdateStatus}
          />
        </div>
      );

    case 'availability':
      return <AvailabilitySection />;

    case 'schedule':
      return <ScheduleSection />;

    case 'earnings':
      return <EarningsSection />;

    case 'clients':
      return <ClientsSection />;

    case 'profile':
      return <ProfileSection />;

    case 'notifications':
      return <NotificationsSection />;

    default:
      return null;
  }
};
